import { BLOG, SINGLE_BLOG } from "@/app/Api/Route_API";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/utils/axiosInstance";

// ── Thunks

export const getBlog = createAsyncThunk(
  "blog/getblog",
  async (page = 1, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BLOG}?page=${page}`);
      if (response?.data?.status === true) {
        return response.data; // { status, message, data: [...], pagination: {...} }
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const getSingleBlog = createAsyncThunk(
  "blog/show",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${SINGLE_BLOG}/${slug}`);
      if (response?.data?.status === true) {
        return response?.data?.data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

// ── Slice ─

const blogSlice = createSlice({
  name: "blog",
  initialState: {
    data: [], // accumulated blog posts across all loaded pages
    singleBlog: null, // single blog post data
    pagination: null, // { total, per_page, current_page, last_page }
    status: "idle", // "idle" | "loading" | "succeeded" | "failed"
    loadingMore: false, // true only when fetching page 2+
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ── getBlog
      .addCase(getBlog.pending, (state, action) => {
        const page = action.meta.arg ?? 1;
        if (page === 1) {
          state.status = "loading"; // full skeleton shown
          state.data = []; // reset posts on fresh load
          state.pagination = null;
        } else {
          state.loadingMore = true; // only bottom spinner
        }
        state.error = null;
      })
      .addCase(getBlog.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        if (pagination.current_page === 1) {
          state.data = data; // replace on first page
        } else {
          state.data = [...state.data, ...data]; // append on subsequent pages
        }
        state.pagination = pagination;
        state.status = "succeeded";
        state.loadingMore = false;
        state.error = null;
      })
      .addCase(getBlog.rejected, (state, action) => {
        state.status = "failed";
        state.loadingMore = false;
        state.error = action.payload;
      })

      // ── getSingleBlog ────────────────────────────────────────────────────
      .addCase(getSingleBlog.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getSingleBlog.fulfilled, (state, action) => {
        state.singleBlog = action.payload;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(getSingleBlog.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default blogSlice.reducer;
